/* lib/api/marketing.js — клиент модуля рассылок (/console/broadcasts).
 * Раздел НЕ привязан к пространству. unwrap → data или throw {status,code,detail}. */
import { apiFetch } from './client.js';
import { unwrap } from './unwrap.js';

// При наличии медиафайла шлём multipart (FormData), иначе JSON.
function buildBody(body) {
  if (body && body.media_file instanceof File) {
    const fd = new FormData();
    for (const [k, v] of Object.entries(body)) {
      if (v == null) continue;
      if (k === 'specific_users' && Array.isArray(v)) v.forEach((id) => fd.append('specific_users', id));
      else if (typeof v === 'boolean') fd.append(k, v ? 'true' : 'false');
      else fd.append(k, v);
    }
    return fd;
  }
  return body;
}

export const listBroadcasts = () => unwrap(apiFetch('/api/marketing/broadcasts/'));
export const getBroadcast = (id) => unwrap(apiFetch(`/api/marketing/broadcasts/${id}/`));
export const createBroadcast = (body) => unwrap(apiFetch('/api/marketing/broadcasts/', { method: 'POST', body: buildBody(body) }));
export const updateBroadcast = (id, body) => unwrap(apiFetch(`/api/marketing/broadcasts/${id}/`, { method: 'PATCH', body: buildBody(body) }));
export const deleteBroadcast = (id) => unwrap(apiFetch(`/api/marketing/broadcasts/${id}/`, { method: 'DELETE' }));

// Live (по текущему контенту, без сохранения).
export const getAudience = (content) => unwrap(apiFetch('/api/marketing/broadcasts/audience/', { method: 'POST', body: content }));
export const getAcademyCourses = () => unwrap(apiFetch('/api/marketing/broadcasts/academy-courses/'));
export const getPreview = (content) => unwrap(apiFetch('/api/marketing/broadcasts/preview/', { method: 'POST', body: content }));
export const sendTest = (id, channel) => unwrap(apiFetch(`/api/marketing/broadcasts/${id}/test/`, { method: 'POST', body: { channel } }));
export const sendNow = (id) => unwrap(apiFetch(`/api/marketing/broadcasts/${id}/send/`, { method: 'POST', body: {} }));
export const cancelBroadcast = (id) => unwrap(apiFetch(`/api/marketing/broadcasts/${id}/cancel/`, { method: 'POST', body: {} }));

export function listDeliveries(id, params = {}) {
  const q = new URLSearchParams();
  for (const k of ['channel', 'status']) if (params[k]) q.set(k, params[k]);
  const qs = q.toString();
  return unwrap(apiFetch(`/api/marketing/broadcasts/${id}/deliveries/${qs ? `?${qs}` : ''}`));
}
export const searchUsers = (qStr) => unwrap(apiFetch(`/api/marketing/users/search/?q=${encodeURIComponent(qStr)}`));
